"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var global_1 = require("../../base/global");
var layer_1 = tslib_1.__importDefault(require("../stack-column/layer"));
var data_1 = require("../../util/data");
var PercentageStackColumnLayer = /** @class */ (function (_super) {
    tslib_1.__extends(PercentageStackColumnLayer, _super);
    function PercentageStackColumnLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'percentageStackColumn';
        return _this;
    }
    PercentageStackColumnLayer.getDefaultOptions = function () {
        return _.deepMix({}, _super.getDefaultOptions.call(this), {
            label: {
                visible: true,
                position: 'middle',
                offset: 0,
            },
            yAxis: {
                visible: true,
                tick: {
                    visible: false,
                },
                grid: {
                    visible: false,
                },
                title: {
                    visible: true,
                },
                label: {
                    visible: false,
                },
            },
        });
    };
    PercentageStackColumnLayer.prototype.processData = function (originData) {
        var _a = this.options, xField = _a.xField, yField = _a.yField;
        return data_1.transformDataPercentage(originData || [], xField, [yField]);
    };
    PercentageStackColumnLayer.prototype.scale = function () {
        var metaConfig = {};
        var yField = this.options.yField;
        metaConfig[yField] = {
            tickCount: 6,
            alias: yField + " (%)",
            min: 0,
            max: 1,
            formatter: function (v) {
                var formattedValue = (v * 100).toFixed(1);
                return formattedValue + "%";
            },
        };
        this.options.meta = metaConfig;
        _super.prototype.scale.call(this);
    };
    return PercentageStackColumnLayer;
}(layer_1.default));
exports.default = PercentageStackColumnLayer;
global_1.registerPlotType('percentageStackColumn', PercentageStackColumnLayer);
//# sourceMappingURL=layer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/percentage-stack-column/layer.js
// module id = 944
// module chunks = 37